import { DynamicColumnTable } from '@/components/organisms'
import { SELECTION_TYPE } from '@/utils/constants/commonConstants'
import { useTierList } from './useTierList'
import { TierFileUploadModal } from '@/containers/ClubPlus/Tabs/Overview/TierFileUploadModal/TierFileUploadModal'

export const TierList = () => {
  const {
    tiers,
    isLoadingTiers,
    getColumns,
    isFileUploadModalOpen,
    setIsFileUploadModalOpen,
    handleModalDismiss,
    setFormData,
    formData
  } = useTierList()

  return (
    <>
      <TierFileUploadModal
        isVisible={isFileUploadModalOpen}
        setIsVisible={setIsFileUploadModalOpen}
        onDismiss={handleModalDismiss}
        formData={formData}
        setFormData={setFormData}
      />
      <DynamicColumnTable
        columns={getColumns()}
        records={tiers}
        showColumnFilters={false}
        selection={SELECTION_TYPE.NONE}
        isLoading={isLoadingTiers}
      />
    </>
  )
}
